import styled from "styled-components";
import { COLORS } from "../../../constants/colors";
import { LinkLegendProps } from "../../../constants/types";

const LinkLegend = (props: LinkLegendProps) => {
  return (
    <Container
      style={{
        color: props.data.color,
      }}
    >
      <span className="label">
        {props.data.label === "공공기관, 기타 상업 건물(해외)"
          ? "기타"
          : props.data.label}
      </span>
    </Container>
  );
};

export default LinkLegend;

const Container = styled.div`
  width: 49%;
  height: 20%;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding-left: 5%;

  .icon {
    font-size: 1vw;
  }

  .label {
    font-size: 1vw;
    font-weight: 500;
    color: ${COLORS.fontColor};
    margin-left: 4%;
    padding-bottom: 1%;
  }
`;
